const Consts = {
    _STORAGE_PREFIX: "sso__",
    STORAGE_NAME_TOKEN: "TOKEN",
    STORAGE_NAME_LOGIN$QQ$STATE: "LOGIN_QQ_STATE"
};


for (let key in Consts) {
    if (key.startsWith("STORAGE_")) {
        Consts[key] = Consts._STORAGE_PREFIX + Consts[key];
    }
}

export default Consts;